export default __webpack_public_path__ + "static/media/inverted-commas.248412b8.svg";